import localCookie from '@liepin/native-sweet-fe';
import cookieUtil from '@liepin/js-core-h5/src/cookie';
import userUtil from './user';
import ajax from './request';
import { apicRoot, wwwRoot } from './domain';

function initUserInfo(force) {
  const userRoles = cookieUtil.get('user_roles');
  const uniqueKey = cookieUtil.get('UniqueKey');
  if (
    !uniqueKey
    || (uniqueKey && !userRoles)
    || (uniqueKey && userRoles && !userRoles.includes('0'))
  ) { // 没有登录 || 登录了没有用户身份 || 登录了但是不是c用户
    return Promise.resolve({});
  }
  const userInfo = localCookie.get('fe_c_user_info');
  if (
    !userInfo
    || (Object.keys(userInfo) && Object.keys(userInfo).length === 0)
    || userInfo.uniqueKey !== uniqueKey
    || force
  ) {
    return ajax.get(`${apicRoot}/api/com.liepin.cresume.get-userc-info`)
      .then(({ data }) => {
        localCookie.set('fe_c_user_info', { ...data, uniqueKey }, 1);
        userUtil.get();
        return data;
      });
  }
  return Promise.resolve(userInfo);
}

export default {
  initUserInfo,
  isLPUser: localCookie.get('fe_c_is_lp_user') || userUtil.isC,
  /**
   * 初始化&获取个人信息
   * @param {Boolean} force 强制刷新数据
   */
  Level: {
    check({ tipType, callback }) {
      userUtil.isC && initUserInfo()
        .then(({ level, goldcard }) => {
          let tips = '';
          switch (tipType) {
            case 1:
              tips = `该企业暂不接受关注请求，建议您应聘<br />适合的企业职位。&nbsp;&nbsp;<a href="${wwwRoot}/sojob/?salary=0$10&jobKind=2">搜索企业职位</a>`;
              break;
            case 2:
              tips = `根据您当前的简历内容和职场资历，金卡服务暂时无法为您提供最佳服务<br />效果，建议您通过应聘企业职位的方式获得发展机会。&nbsp;&nbsp;<a href="${wwwRoot}/sojob/?salary=0$10&jobKind=2">搜索企业职位</a>`;
              break;
            case 3:
              tips = `该企业暂不接受在线咨询，建议您应聘<br />适合的企业职位。&nbsp;&nbsp;<a href="${wwwRoot}/sojob/?salary=0$10&jobKind=2">搜索企业职位</a>`;
              break;
            default:
              tips = `您目前暂未达到猎头顾问搜寻人选的条件，建议您通过<br />应聘企业职位的方式获得发展机会。&nbsp;&nbsp;<a href="${wwwRoot}/sojob/?salary=0$10&jobKind=2">搜索企业职位</a>`;
          }
          (tipType === 2 || !goldcard)
            && (level === 0 || level === 1)
            && callback && callback.call(this, tips);
          return null;
        });
    },
  },
};
